import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../CSS/Contact.css";

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    Email_ad: '',
    phno: '',
    Subject: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validatePhoneNumber = (number) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(number);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, Email_ad, phno, Subject, message } = formData;

    // Validate phone number
    if (!validatePhoneNumber(phno)) {
      setStatus(t('Invalid Indian phone number. If not indian then try sending a email to ramswaroop.exe@gmail.com . I will reach to you as soon as possible.'));
      toast.error(t('Invalid Indian phone number.If not indian then try sending a email to ramswaroop.exe@gmail.com'));
      return;
    }

    if (!name || !Email_ad || !phno || !Subject || !message) {
      setStatus(t('Please fill in all fields.'));
      toast.error(t('Please fill in all fields.'));
      return;
    }

    const templateParams = {
      Name: name,
      Email_ad: Email_ad,
      phno: phno,
      Subject: Subject,
      message: message,
    };

   

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        setStatus(t('Message sent successfully!'));
        toast.success(t('Message sent successfully!Will reach to you as soon as possible.'));
        setFormData({
          name: '',
          Email_ad: '',
          phno: '',
          Subject: '',
          message: '',
        });
      })
      .catch((err) => {
        console.error('FAILED...', err);
        setStatus(t('Failed to send message. Please try again or email me.'));
        toast.error(t('Failed to send message. Please try again or email me.'));
      });
  };

  return (
    <div className="contact-container">
      <h1>{t('Contact')}</h1>
      <form onSubmit={handleSubmit}>
        <label>{t('Name')}</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          className="contact-input"
        />
        <label>{t('Email')}</label>
        <input
          type="email"
          name="Email_ad"
          value={formData.Email_ad}
          onChange={handleChange}
          required
          className="contact-input"
        />
        <label>{t('Phone Number (10 digits) only ')}</label>
        <input
          type="tel"
          name="phno"
          value={formData.phno}
          onChange={handleChange}
          required
          className="contact-input"
        />
        <label>{t('Subject')}</label>
        <input
          type="text"
          name="Subject"
          value={formData.Subject}
          onChange={handleChange}
          required
          className="contact-input"
        />
        <label>{t('Message')}</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          className="contact-textarea"
        ></textarea>
        <button type="submit" className="contact-button">{t('Send')}</button>
        {status && (
          <p className={`status-message ${status.includes('Failed') ? 'error' : 'success'}`}>
            {status}
          </p>
        )}
      </form>
      <ToastContainer />
    </div>
  );
};

export default Contact;